import React from 'react';

import { ProductType } from 'constants/product';

//
// --- Types ---

interface LayoutMatchProps {
  children: React.ReactChild;
  /** boolean of whether this is for the discovery version of the app or not
   * needs to be lowercase or else there is a console error */
  isDiscovery: boolean;
  /** LayoutSwitch support single product type or an array of product types to match against */
  product: ProductType | ReadonlyArray<ProductType>;
}

//
// --- LayoutMatch Component ---

/**
 * Meant to be used as children in `LayoutSwitch` components. Requires a `product` prop and a
 * `isDiscovery` prop so they can be used to match against in `LayoutSwitch`. This
 * component simply returns its children for rendering purposes
 */
const LayoutMatch: React.FC<LayoutMatchProps> = ({ children }) => {
  return children as JSX.Element;
};

export default LayoutMatch;
